import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { nombreVisible } from '../utils/jugadores';

// En el lado público (fuera de /privado) un jugador se muestra con su alias
// y, si no lo tiene, con su nombre real. En el dashboard, donde se gestiona el
// catálogo, se sigue viendo el nombre completo.
export const nombreJugador = (jugador, publico) => (publico ? nombreVisible(jugador) : jugador?.nombre ?? '');

export default function useNombreJugador() {
  const { pathname } = useLocation();
  const publico = !pathname.startsWith('/privado');
  return useCallback((jugador) => nombreJugador(jugador, publico), [publico]);
}
